declare namespace $ {

	export class $shm_service_task_menu extends $shm_remove_menu {
		remove_confirm_title( ): string
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map